import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class ProductDetailsCardStyle {
    /**
     * @param options Options object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color } = options.theme;
        return css `
			${Text.CSS}

			skapa-product-identifier {
				margin-bottom: ${spacing.space300 / 16}rem;
			}

			kompis-accordion-item-padding {
				padding-top: 0;
				padding-bottom: 0;
			}

			.header {
				display: flex;
				margin-bottom: ${spacing.space100 / 16}rem !important;
			}

			.distanceSelling {
				display: flex;
				flex-direction: column;
				margin-bottom: ${spacing.space200 / 16}rem !important;
			}

			.textTypeSubHeading {
				margin-block-start: 0;
				margin-block-end: ${spacing.space50 / 16}rem;
			}

			.goodToKnow > span:not(:last-child),
			.customerMaterial > span:not(:last-child),
			.safetyAndCompliance > span:not(:last-child),
			.careInstruction > span:not(:last-child),
			.sustainabilityAndEnvironment > span:not(:last-child),
			.customerBenefits > span:not(:last-child) {
				display: flex;
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.goodToKnow,
			.safetyAndCompliance,
			.sustainabilityAndEnvironment,
			.customerBenefits,
			.customerMaterial span:last-child,
			.careInstruction span:last-child,
			kompis-wood-declaration-card,
			kompis-divider {
				display: flex;
				flex-direction: column;
				margin-bottom: ${spacing.space150 / 16}rem;
			}

			.customerMaterial span.textPart {
				color: ${color.text.default};
				margin-bottom: 0rem;
			}

			.materialAndCareHeader {
				display: flex;
				margin-bottom: ${spacing.space100 / 16}rem !important;
				color: ${color.text.dark};
			}

			.customerMaterial {
				display: flex;
				flex-direction: column;
			}

			.materialsAndCare {
				display: flex;
				flex-direction: column;
			}

			.distanceSellingHeader {
				color: ${color.text.default};
			}

			/* Overrides user agent styling. */
			.header,
			.distanceSellingHeader,
			.materialAndCareHeader,
			.textPart {
				margin-block-end: 0;
				margin-block-start: 0;
			}
		`;
    }
}
//# sourceMappingURL=ProductDetailsCardStyle.js.map